import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { IErrorModel, IPaginatedResponse } from '@core/models/generic.model';
import alertService from 'services/api/alert.service';

// -------------------------------------------------------------------------

interface IAlertSliceState {
    loading: boolean;
    error: IErrorModel | undefined;
    alerts: IPaginatedResponse | null;
}

const initialState: IAlertSliceState = {
    loading: false,
    error: {} as IErrorModel,
    alerts: null,
};

// -------------------------------------------------------------------------

export const getAlertThunk = createAsyncThunk<
    IPaginatedResponse,
    { size: number; page: number; productId: string },
    { rejectValue: IErrorModel }
>(`/alert/getAlert`, async (params, { rejectWithValue }: any) => {
    try {
        const response: any = await alertService.getAlert(params);
        return response.data.alerts;
    } catch (err: any) {
        toast.error(err.errorMessage || 'Failed to fetch alert data', { autoClose: 5000 });
        return rejectWithValue(err);
    }
});

// -------------------------------------------------------------------------


const alertSlice = createSlice({
    name: `alert`,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get Alert
        builder.addCase(getAlertThunk.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getAlertThunk.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.alerts = action.payload;
        });
        builder.addCase(getAlertThunk.rejected, (state, action) => {
            state.loading = false;
            state.alerts = null;
            state.error = action.payload;
        });
    }
});

// -------------------------------------------------------------------------

export default alertSlice;
export const alertReducer = alertSlice.reducer;

